import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import React from "react";

const buttonVariants = {
  primary: "bg-bambu-green text-white hover:bg-bambu-dark-green focus:ring-bambu-green",
  secondary: "bg-bambu-gray-light text-bambu-green border-2 border-bambu-green hover:bg-white focus:ring-bambu-green",
  outline: "bg-transparent border border-bambu-green text-bambu-green hover:bg-bambu-green/10",
  ghost: "bg-transparent text-bambu-black hover:bg-bambu-green-pastel",
  danger: "bg-bambu-red text-white hover:bg-red-600 focus:ring-red-500",
};

const sizes = {
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-6 py-3 text-lg",
};

export function Button({
  className,
  variant = "primary",
  size = "md",
  isLoading = false,
  disabled,
  children,
  ...props
}) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center rounded-lg font-montserrat font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50",
        buttonVariants[variant],
        sizes[size],
        className
      )}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
}
